module.exports = __webpack_public_path__ + "img/Ask A Doctor.81597f2.png";